import { Layout } from 'CorePackage/MainModule/components/Layout';

import { Knm } from './Knm';
import { ErpPmRouteGuard } from './ErpPmRouteGuard';

export const KnmPage = () => (
  <Layout withFooter>
    <ErpPmRouteGuard />
    <Knm />
  </Layout>
);
